import type { ReactNode } from 'react';

type TrainColumn = {
  name: string;
  label: string;
  render?: (val: any, row?: any) => ReactNode;
};

export const trainColumns: TrainColumn[] = [
  {
    name: 'role',
    label: 'Role',
    render: (_: unknown, row: any) => row?.org_chart_node?.name ?? '-',
  },
  {
    name: 'category',
    label: 'Category',
    render: (_val: string, row: any) => {
      const val = row?.type ?? _val;
      const colorMap: Record<string, string> = {
        Skill: 'text-green-700 bg-green-100 border-green-300',
        Attitude: 'text-blue-700 bg-blue-100 border-blue-300',
        Knowledge: 'text-purple-700 bg-purple-100 border-purple-300',
      };
      const colorClass = colorMap[val] || 'text-gray-700 bg-gray-100 border-gray-300';
      return <span className={`border inline-block px-2 rounded-lg ${colorClass}`}>{val || '-'}</span>;
    },
  },
  { name: 'name', label: 'Name' },
  {
    name: 'description',
    label: 'Description',
    render: (val: string) => <div className="max-w-xs truncate" dangerouslySetInnerHTML={{ __html: val || '-' }} />,
  },
  {
    name: 'is_published',
    label: 'Publish',
    render: (val: boolean) =>
      val ? (
        <span className="text-green-700 bg-green-100 border inline-block border-green-300 px-2 rounded-lg">
          Published
        </span>
      ) : (
        <span className="text-red-700 bg-red-100 border inline-block border-red-300 px-2 rounded-lg">Unpublished</span>
      ),
  },
];
